import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../../pages/popup/PopupProfileEdit"
import PopupRegisterCoupon from "../../pages/popup/PopupRegisterCoupon"
import PopupPlusMember from "../../pages/popup/PopupPlusMember"

import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PaginationMemberList from '../../components/PaginationMemberList';
import { Rotate } from 'react-reveal';

export default function PlusMember() {
    const location = useLocation();

    const {
        teamId
    } = location.state || {};

    const [team, setTeam] = useState({});
    const teams = useSelector((state) => state.teamReducer.teams);

    const getTeamDetail = async () => {
        let team = teams.find(t => t.id === teamId);
        const res = await API.get(`team/${teamId}`);
        console.log("team : ", team, ", res : ", res.data);
        team = res.data;
        const normalUsers = team.users.map(user => ({ ...user, invited: false }));
        const invitedUsers = team.invitedUsers.map(user => ({ ...user, invited: true }));
        const invitesNonUsers = team.invitesNonUsers.map(user => ({ ...user, invited: true }));

        const mergedUsers = invitesNonUsers ? [...normalUsers, ...invitedUsers, ...invitesNonUsers] : [...normalUsers, ...invitedUsers];

        mergedUsers.sort((a, b) => new Date(a.teamAt) - new Date(b.teamAt));
        team.users = mergedUsers;

        setTeam(team);
    };

    useEffect(() => {
        console.log("teamId : ", teamId);
        if (teamId) {
            getTeamDetail();
        }
    }, [teamId]);

    const group_name = team.name;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const lang = useSelector(state => state.langReducer.lang); // 추가된 lang selector

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [modifyLicense, setModifyLicense] = useState(0);

    const [dropView, setDropView] = useState(false);

    const [selDrop, setSelDrop] = useState(lang === 0 ? "전체" : "All");
    const droplist_sample = [
        lang === 0 ? "전체" : "All",
        lang === 0 ? "라이선스 활성" : "License Active",
        lang === 0 ? "라이선스 비활성" : "License Inactive"
    ];

    const [selectedItems, setSelectedItems] = useState([]);  // 체크된 리스트
    const [chkReset, setChkReset] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!mbData?.idx) {
            navigate(routes.main);
        }
    }, []);

    const popupOpen = useSelector((state) => state.popupReducer.open);

    useEffect(() => {
        if (!popupOpen) {
            getTeamDetail();
        }
    }, [popupOpen]);

    /* useEffect(() => {
        console.log(selectedItems)
    }, [selectedItems]); */

    const PlusMemberFunc = (type) => {
        if (type === 'name_edit') {
            dispatch(open({
                component:
                    <PopupPlusMember
                        max_width={'400px'}
                        popType={'group'}
                        groupEdit={true}
                        button={lang === 0 ? '저장' : 'Save'}
                        buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                        groupName={group_name}
                        teamId={team.id}
                    />
            }));
        }

        if (type === 'plus_member') {
            dispatch(open({
                component:
                    <PopupPlusMember
                        max_width={'400px'}
                        button={lang === 0 ? '등록' : 'Register'}
                        buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                        plusMember={true}
                        group_name_get={group_name}
                        teamId={team.id}
                    />
            }));
        }
    }

    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default} />
                            <p>{lang === 0 ? '멤버 관리' : 'Member Management'}</p>
                        </div>

                        <div className="profile_edit coupon plus_member">
                            <div className="coupon_title_box plus_member">
                                <p>
                                    {group_name}
                                    <img
                                        src={require("../../assets/icon/edit-line.svg").default}
                                        onClick={() => {
                                            PlusMemberFunc('name_edit');
                                        }}
                                    />
                                </p>

                                {/* <div className="info_box">
                                    <div className="info">
                                        <p>활성 라이선스</p>
                                        <span>2</span>
                                    </div>

                                    <div className="info sub">
                                        <p>잔여 라이선스</p>
                                        <span>8</span>
                                    </div>
                                </div> */}

                                <button
                                    type="button"
                                    onClick={() => {
                                        PlusMemberFunc('plus_member');
                                    }}
                                >
                                    <img src={require("../../assets/icon/add_white.svg").default} />
                                    {lang === 0 ? '멤버 추가' : 'Add Member'}
                                </button>
                            </div>

                            <div className="sub_title_box">
                                <div className="info_box">
                                    <p>{lang === 0 ? '멤버:' : 'Members:'}</p>
                                    <span>{team.users?.length || 0}</span>
                                </div>
                                {/* {modifyLicense == 0 &&
                                    <div className="license_btn_box">
                                        <button
                                            type="button"
                                            className="on"
                                            onClick={() => {
                                                setModifyLicense(1);
                                                setChkReset(false)
                                            }}
                                        >
                                            <img src={require("../../assets/icon/license_on.svg").default}/>
                                            라이선스 할당
                                        </button>

                                        <button
                                            type="button"
                                            className="delete"
                                            onClick={() => {
                                                setModifyLicense(2);
                                                setChkReset(false)
                                            }}
                                        >
                                            <img src={require("../../assets/icon/trash.svg").default}/>
                                            라이선스 제거
                                        </button>
                                    </div>
                                } */}

                                {/* {modifyLicense != 0 &&
                                    <div className="license_btn_box">
                                        <button
                                            type="button"
                                            className="on"
                                            onClick={() => {
                                                if(selectedItems.length === 0) {
                                                    dispatch(open({
                                                        component: 
                                                            <Popup01
                                                                max_width={'300px'}
                                                                text1={'멤버를 선택해 주세요.'}
                                                                longButton={'확인'}
                                                            />
                                                    }));
                                                } else {
                                                    if(modifyLicense == 1) {
                                                        dispatch(open({
                                                            component: 
                                                                <Popup01
                                                                    max_width={'300px'}
                                                                    text1={'라이선스를 할당하시겠습니까?'}
                                                                    buttonCancel={'닫기'}
                                                                    button={'할당'}
                                                                />
                                                        }));
                                                    }

                                                    if(modifyLicense == 2) {
                                                        dispatch(open({
                                                            component: 
                                                                <Popup01
                                                                    max_width={'300px'}
                                                                    text1={'라이선스를 제거하시겠습니까?'}
                                                                    buttonCancel={'닫기'}
                                                                    button={'제거'}
                                                                />
                                                        }));
                                                    }
                                                }
                                            }}
                                        >
                                            <img src={require("../../assets/icon/solid_check_white.svg").default}/>
                                            선택 목록 {modifyLicense == 1 ? '할당' : modifyLicense == 2 ? '제거' : '변경'}
                                        </button>

                                        <button
                                            type="button"
                                            className="delete set"
                                            onClick={() => {
                                                setModifyLicense(0);
                                                setChkReset(true)
                                            }}
                                        >
                                            취소
                                        </button>
                                    </div>
                                } */}


                                <div className="search_box">
                                    <div className="input_box">
                                        <input type="text" placeholder={lang === 0 ? "이메일, 이름" : "Email, Name"} />
                                        <img src={require("../../assets/icon/search_black.svg").default} />
                                    </div>

                                    {/* <div 
                                        className={`drop_box ${dropView ? 'on' : ''}`}
                                        onClick={() => {
                                            setDropView(!dropView)
                                        }}
                                    >
                                        {selDrop}

                                        {dropView &&
                                            <div className="drop_list">
                                                {droplist_sample.map((x, i) => (
                                                    <p 
                                                        key={i}
                                                        onClick={() => {
                                                            setSelDrop(x)
                                                        }}
                                                    >
                                                        {x}
                                                    </p>
                                                ))}
                                            </div>
                                        }
                                    </div> */}
                                </div>
                            </div>

                            <PaginationMemberList
                                coupon={team.users}
                                chkReset={chkReset}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                modifyLicense={modifyLicense}
                                teamId={team.id}
                            />
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
